<ng-container *ngIf="ProfileListCard && !scormData && [null, undefined, ''].includes(assessmentScore)">
    <div class="enrollers" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <div class="user-pic" fxFlex="0 0 40px">
            <ng-container *ngIf="![null, undefined, ''].includes(ProfileListCard?.profilePicURL)">
                <img [src]="ProfileListCard?.profilePicURL" (error)="gfService.setErrorImage($event, 'man')">
            </ng-container>
            <ng-container *ngIf="[null, undefined, ''].includes(ProfileListCard?.profilePicURL)">
                <img src="assets/img/man.png">
            </ng-container>
        </div>
        <div class="cm-right-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch"
            fxLayoutGap="4px">
            <div class="user-details" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
                <span class="entity-title linkable">{{ProfileListCard.name}}</span>

                <div class="user-info" fxLayoutGap="3px" fxLayoutGap.xs="1px">
                    <ng-container *ngFor="let data of ProfileListCard?.shortInfo; let isLast = last">
                        <span class="sub-text-1">{{data.value}}</span>
                        <ng-container *ngIf="!isLast">
                            <span>|</span>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="overfiew" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <ng-container *ngIf="ProfileListCard?.date">
                    <span class="date-item">{{ProfileListCard?.date}}</span>
                </ng-container>
                <ng-container *ngIf="ProfileListCard?.completedPercent <= 100 && !ProfileListCard?.completionDate">
                    <div fxFlex="0 1 20%" fxFlex.xs="auto" fxLayoutAlign="start center">
                        <mat-progress-bar class="progress-br" color="primary" mode="determinate"
                            [value]=ProfileListCard?.completedPercent> 
                        </mat-progress-bar>
                    </div>
                </ng-container>
                <ng-container *ngIf="ProfileListCard?.completedPercent >= 100 && ProfileListCard.scoredPercentage >= 0">
                    <div fxFlex="0 1 20%" fxFlex.xs="auto" fxLayoutAlign="start center">
                        <mat-progress-bar class="progress-br" color="primary" mode="determinate"
                            [value]=ProfileListCard?.completedPercent>  
                        </mat-progress-bar>
                    </div>
                </ng-container>
                <ng-container *ngIf="ProfileListCard?.completedPercent >= 100 && ProfileListCard?.completionDate && [null, undefined, ''].includes(ProfileListCard.scoredPercentage)">
                    <div fxFlex="0 1 20%" fxFlex.xs="auto" fxLayoutAlign="start center">
                        <mat-progress-bar class="progress-br" color="primary" mode="determinate"
                            [value]=ProfileListCard?.completedPercent>  
                        </mat-progress-bar>
                    </div>
                </ng-container>
            </div>
            <ng-container *ngIf="ProfileListCard?.completedPercent >= 100 && ProfileListCard.scoredPercentage >= 0">
                <div class="overfiew" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <ng-container *ngIf="ProfileListCard?.completionDate">
                        <span class="date-item">{{ locale.translate('completed') }} :{{ProfileListCard?.completionDate}}</span>
                    </ng-container>
                    <span class="body-text">{{ locale.translate('score') }} : </span>
                    <p class="score-dtls">{{ProfileListCard?.scoredPercentage}} %
                    </p>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>
<ng-container *ngIf='ProfileListCard && assessmentScore >= 0'>
    <div class="enrollers" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <div class="user-pic" fxFlex="0 0 40px">
            <ng-container *ngIf="![null, undefined, ''].includes(ProfileListCard?.profilePicURL)">
                <img [src]="ProfileListCard?.profilePicURL" (error)="gfService.setErrorImage($event, 'man')">
            </ng-container>
            <ng-container *ngIf="[null, undefined, ''].includes(ProfileListCard?.profilePicURL)">
                <img src="assets/img/man.png">
            </ng-container>
        </div>
        <div class="cm-right-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch"
            fxLayoutGap="4px">
            <div class="user-details" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
                <span class="entity-title linkable">{{ProfileListCard.name}}</span>
                <div class="user-info" fxLayoutGap="3px" fxLayoutGap.xs="1px">
                    <ng-container *ngFor="let data of ProfileListCard?.shortInfo; let isLast = last">
                        <span class="sub-text-1">{{data.value}}</span>
                        <ng-container *ngIf="!isLast">
                            <span>|</span>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="overfiew" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <ng-container *ngIf="![null, undefined, ''].includes(assessmentScore) && assessmentScore >= 0">
                    <span class="body-text">{{ locale.translate('score') }} : </span>
                    <p class="score-dtls">{{assessmentScore}} / 100 ({{assessmentScore}}%)
                    </p>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>
<!-- <ng-container *ngIf="ProfileListCard && ![null, undefined, ''].includes(scormData)">
    <div class="enrollers" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <div class="user-pic" fxFlex="0 0 40px">
            <ng-container *ngIf="![null, undefined, ''].includes(ProfileListCard?.profilePicURL)">
                <img [src]="ProfileListCard?.profilePicURL" (error)="gfService.setErrorImage($event, 'man')">
            </ng-container>
            <ng-container *ngIf="[null, undefined, ''].includes(ProfileListCard?.profilePicURL)">
                <img src="assets/img/man.png">
            </ng-container>
        </div>
        <div class="cm-right-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch"
            fxLayoutGap="4px">
            <div class="user-details" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
                <span class="entity-title linkable">{{ProfileListCard.name}}</span>
                <div class="user-info" fxLayoutGap="3px" fxLayoutGap.xs="1px">
                    <ng-container *ngFor="let data of ProfileListCard?.shortInfo; let isLast = last">
                        <span class="sub-text-1">{{data.value}}</span>
                        <ng-container *ngIf="!isLast">
                            <span>|</span>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="overfiew" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <ng-container *ngIf="ProfileListCard?.completionDate">
                    <div class="tick-icon" >
                        <mat-icon svgIcon="tick_mark"></mat-icon>
                    </div>
                     <span class="date-item"> {{ locale.translate('completed') }}</span>
                </ng-container>
                <ng-container *ngIf="![null, undefined, ''].includes(scormData)">
                    <span class="body-text">{{ locale.translate('score') }} : </span>
                    <p class="score-dtls">{{scormData}} %
                    </p>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container> -->